/* eslint-disable camelcase */
import gptPulseService from '@/services/API/GptPulse';

const ENTITY_TYPES = {
  course: {
    createMethodName: 'createCourseGptSettings',
    name: 'Курса',
  },
  course_module: {
    createMethodName: 'createModuleGptSettings',
    name: 'Модуля',
  },
  course_unit: {
    createMethodName: 'createUnitGptSettings',
    name: 'Темы',
  },
  task: {
    name: 'Темы',
  },
};

export default class GptSettings {
  constructor(item, entityType, parentEntity) {
    this.id = item.id;
    this.type = item.type || 0;
    this.knowledge_base_id = item.knowledge_base_id || null;
    this.knowledgeBaseName = null;
    this.course = item.course;
    this.module = item.course_module;
    this.unit = item.course_unit;
    this.task_unit = item.task_unit;
    this.entityType = entityType;
    this.parentEntity = parentEntity;
    this.auto_percent = item.auto_percent;
    this.evaluation_type = item.evaluation_type;
    this.evaluation_max = item.evaluation_max;
    this.auto_checkout_value = item.auto_checkout_value;

    this.getKnowledgeBase();
  }

  get entity() {
    return this.course || this.module || this.unit || this.task_unit;
  }

  get name() {
    return this.course?.title || this.module?.name || this.unit?.name || this.task_unit.title;
  }

  async getKnowledgeBase() {
    const { knowledge_base_id, entity, entityType } = this;
    if (knowledge_base_id) {
      const { data } = await gptPulseService.showKnowledgeBase(knowledge_base_id);
      this.knowledgeBaseName = data.data.name;
    } else {
      this.knowledgeBaseName = `БЗ ${ENTITY_TYPES[entityType].name} - "${entity.title || entity.name}"`;
    }
  }

  setBaseKnowledge({ id, name }) {
    this.knowledgeBaseName = name;
    this.knowledge_base_id = id;
    this.handleSave();
  }

  handleSave() {
    const { id } = this;
    if (id) {
      this.saveEntity();
    } else {
      this.createEntity();
    }
    // return id ? this.saveEntity : this.createEntity;
  }

  async saveEntity() {
    const {
      id,
      knowledge_base_id, type, auto_percent, evaluation_type, evaluation_max, auto_checkout_value,
    } = this;
    const params = {
      knowledge_base_id,
      type,
      ...this.entityType === 'task' ? {
        auto_percent,
        evaluation_type,
        evaluation_max,
        auto_checkout_value,
      } : {},
    };
    await gptPulseService.updateGptSettings(id, params);
  }

  async createEntity() {
    const { type, entityType, parentEntity } = this;
    const method = ENTITY_TYPES[entityType].createMethodName;

    if (!this.knowledge_base_id) {
      const { data } = await gptPulseService.createKnowledgeBases({ name: this.knowledgeBaseName });
      this.knowledge_base_id = data.data.id;
    }

    const { knowledge_base_id } = this;
    const params = { knowledge_base_id, type };
    if (this.unit) {
      const name = `${parentEntity.type}_id`;
      params[name] = Number(parentEntity.id);
    }
    const { data } = await gptPulseService[method](this.entity.id, params);
    this.id = data.data.id;
  }
}
